// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","channelLogo":"_2BFceC","fadeInFrames":"_22Ufa4"};